export default __webpack_public_path__ + "static/media/esgCircle.b9818582.svg";